// document.addEventListener('DOMContentLoaded', function () {
//   if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
//     console.warn('GSAP or ScrollTrigger not loaded.');
//     return;
//   }

//   gsap.registerPlugin(ScrollTrigger);

//   const sections = document.querySelectorAll('.section--tab-video-gallery');

//   sections.forEach((section) => {
//     const tabs = section.querySelectorAll('.tab-video-gallery__tab');
//     const videos = section.querySelectorAll('.tab-video-gallery__video');

//     if (!tabs.length || !videos.length) return;

//     let currentStep = 0;
//     const totalSteps = tabs.length;

//     const stepHeight = window.innerHeight;
//     const totalHeight = totalSteps * stepHeight;

//     ScrollTrigger.create({
//       trigger: section,
//       start: 'bottom bottom',
//       end: () => `+=${totalHeight}`,
//       pin: true,
//       anticipatePin: 1,
//       scrub: false,
//       onUpdate: (self) => {
//         const scrollPos = self.scroll();
//         const scrollTop = self.start;
//         const progress = (scrollPos - scrollTop) / totalHeight;
//         const newStep = Math.floor(progress * totalSteps);

//         if (newStep !== currentStep && newStep >= 0 && newStep < totalSteps) {
//           currentStep = newStep;

//           // Update tab
//           tabs.forEach((tab, i) => {
//             tab.classList.toggle('tab-video-gallery__tab--active', i === currentStep);
//           });

//           // Update video
//           videos.forEach((video, i) => {
//             video.classList.toggle('tab-video-gallery__video--active', i === currentStep);

//             if (i === currentStep) {
//               const videoEls = video.querySelectorAll('video');
//               videoEls.forEach((videoEl) => {
//                 videoEl.currentTime = 0;
//                 videoEl.play().catch(() => {});
//               });
//             }
//           });
//         }
//       }
//     });
//   });
// });

document.addEventListener('DOMContentLoaded', function () {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    console.warn('GSAP or ScrollTrigger not loaded.');
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  const sections = document.querySelectorAll('.section--tab-video-gallery');
  const SCROLL_FACTOR = 1.25;

  sections.forEach((section) => {
    const tabs = section.querySelectorAll('.tab-video-gallery__tab');
    const videos = section.querySelectorAll('.tab-video-gallery__video');

    if (!tabs.length || !videos.length) return;

    let currentStep = 0;
    const totalSteps = tabs.length;

    const stepHeight = window.innerHeight;
    const totalHeight = totalSteps * stepHeight * SCROLL_FACTOR;

    ScrollTrigger.create({
      trigger: section,
      start: 'bottom bottom',
      end: () => `+=${totalHeight}`,
      pin: true,
      anticipatePin: 1,
      scrub: false,
      onUpdate: (self) => {
        const scrollPos = self.scroll();
        const scrollTop = self.start;
        const progress = (scrollPos - scrollTop) / totalHeight;
        const newStep = Math.floor(progress * totalSteps);

        if (newStep !== currentStep && newStep >= 0 && newStep < totalSteps) {
          currentStep = newStep;

          // Update tab
          tabs.forEach((tab, i) => {
            const isActive = i === currentStep;
            const wasActive = tab.classList.contains('tab-video-gallery__tab--active');

            tab.classList.toggle('tab-video-gallery__tab--active', isActive);

            const description = tab.querySelector('.tab-video-gallery__description');

            if (window.innerWidth > 990 && description) {
              if (isActive && !wasActive) {
                // EXPAND with timeline
                gsap.killTweensOf(description);
                const fullHeight = description.scrollHeight;

                const tlExpand = gsap.timeline();
                tlExpand.set(description, { visibility: 'visible', height: 'auto' });

                tlExpand.fromTo(description,
                  { height: 0 },
                  {
                    height: fullHeight,
                    duration: 0.5,
                    ease: 'none'
                  }, 0
                );

                tlExpand.fromTo(description,
                  { opacity: 0 },
                  {
                    opacity: 1,
                    duration: 0.5,
                    ease: 'none'
                  }, 0
                );

                tlExpand.set(description, { height: 'auto' });
              }

              if (!isActive && wasActive) {
                // COLLAPSE with timeline
                gsap.killTweensOf(description);
                const currentHeight = description.scrollHeight;

                const tlCollapse = gsap.timeline();
                tlCollapse.fromTo(description,
                  { height: currentHeight },
                  {
                    height: 0,
                    duration: 0.4,
                    ease: 'none'
                  }, 0
                );

                tlCollapse.fromTo(description,
                  { opacity: 1 },
                  {
                    opacity: 0,
                    duration: 0.4,
                    ease: 'none'
                  }, 0
                );

                tlCollapse.set(description, { visibility: 'hidden' });
              }
            }
          });

          // Update video
          videos.forEach((video, i) => {
            video.classList.toggle('tab-video-gallery__video--active', i === currentStep);

            if (i === currentStep) {
              const videoEls = video.querySelectorAll('video');
              videoEls.forEach((videoEl) => {
                videoEl.currentTime = 0;
                videoEl.play().catch(() => {});
              });
            }
          });
        }
      }
    });
  });
});